import { Component, ElementRef} from '@angular/core';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { UserService } from './services/user.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})

export class AppComponent {
  
    title = 'Medimail Patient';

    public constructor(private titleService: Title, 
                       private router: Router, 
                       private userService: UserService,
                       public translate: TranslateService,
                       private elRef: ElementRef
                       ) 
    { 
        this.titleService.setTitle(this.title);

        translate.addLangs(environment.locales);
        if (translate.currentLang == null) {
            if (localStorage.getItem('language') !== undefined && localStorage.getItem('language') != null) {
                translate.currentLang = localStorage.getItem('language')!;                
            } else {
                translate.currentLang = translate.getDefaultLang();
                localStorage.setItem('language', translate.getDefaultLang());
            }
        }
        
        translate.reloadLang(localStorage.getItem('language')!);
        
        //@ts-ignore
        this.router.events.subscribe((event: Event) => {
            if (event instanceof NavigationStart) {
      
                if (this.userService.isAuthenticated()) {
      
                    const exp = this.userService.currentUser.keycloakUser.refreshTokenParsed.exp;
                    const iat = this.userService.currentUser.keycloakUser.refreshTokenParsed.iat;
                    const timeWindow = (exp - iat) / 2;
                    const now = Date.now() / 1000;
        
                    if ((exp - timeWindow) < now) {
                        this.userService.refreshToken()
                            .then((response) => {
                                //console.log('Updated token');
                            })
                            .catch((error) => console.error(error));
                    }
                }
                // Show loading indicator
            }
      
            if (event instanceof NavigationEnd) {
              // Hide loading indicator
            }
      
            if (event instanceof NavigationError) {
              // Hide loading indicator
      
              // Present error to user
              //console.log(event.error);
            }
        });

        //Mise à jour du template pour monaco
        if (this.userService.currentUser.template) {
            if (this.userService.currentUser.template.name) {
                const linkEl = document.createElement('link');
                linkEl.setAttribute('rel', 'stylesheet');
                linkEl.href = this.userService.currentUser.template.name + ".css";
                document.head.appendChild(linkEl);
            } else {
                const linkEl = document.createElement('link');
                linkEl.setAttribute('rel', 'stylesheet');
                linkEl.href = "styles.css";
                document.head.appendChild(linkEl);
            }
        } else {
            const linkEl = document.createElement('link');
            linkEl.setAttribute('rel', 'stylesheet');
            linkEl.href = "styles.css";
            document.head.appendChild(linkEl);
        }
    }

}
